import { MINIDIFTMEN_NAMES, Minidiftman } from '../Minidiftman'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'
import type { CSSProperties } from 'react'

interface ProjectCommentsProps {
  project: Project
  className?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectComments({
  project,
  className = '',
  style = emptyObject,
  locale,
}: ProjectCommentsProps) {
  const t = i18n[locale] ?? i18n.fr
  if (!project.some_comments || project.some_comments.length === 0) return null

  const comments = (
    project.some_comments.length === 4
      ? project.some_comments
      : [project.some_comments[0], project.some_comments[1]]
  ).filter(text => Boolean(text))

  return (
    <>
      <hr className="w-full text-medium-gray" />

      <div className={className} style={style}>
        <div className="mb-6 text-lg font-semibold">{t.title}</div>
        <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-2">
          {comments.map((comment, index) => (
            <div
              key={`comment-${MINIDIFTMEN_NAMES[index]}`}
              className="flex h-[80px] w-full items-center rounded-xl bg-light-gray px-4 py-3"
            >
              <Minidiftman variant={MINIDIFTMEN_NAMES[index]} size="big" />
              <div className="ml-4 line-clamp-2 text-sm font-medium">
                {comment}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
